import React from 'react';
import './../scss/LoadMoreButton.scss';

const { __, getLocaleData } = window.wp.i18n;

class LoadMoreButton extends React.Component {
  render () {
    return (
      <a className="filters-more" aria-label={ __('Load More about jobs', 'macs-react-jobs') } role="button" tabIndex="0" onClick={this.props.loadMore}>{ __('Load More', 'macs-react-jobs') }</a>
    );
  }
}

export default LoadMoreButton;
